import { useCallback, useEffect } from 'react';
import { useSlateStatic, ReactEditor } from 'slate-react';
import { dragIconHorizontal } from '../../../../../../assets/hostedassets';
import styles from './TableHeader.module.scss';
import {
    applyColumnSelection,
    applyRowSelection,
    handleColumnSelect,
    handleRowSelect,
    isCurrentColumnSelected,
} from '../tableSelectionUtils';
import clsx from 'clsx';

function TableHeader(props) {
    const editor: any = useSlateStatic();

    return (
        <th
            {...props.attributes}
            className={clsx(styles.TableHeader, {
                [styles.TableHeaderSelected]: isCurrentColumnSelected(editor, props?.element),
                [styles.TableHeader_RowSelected]: props.element?.isRowSelected,
            })}
            {...(!!isCurrentColumnSelected(editor, props?.element) && { 'data-column-selector': true })}
            {...(!!props.element?.isRowSelected && { 'data-row-selector': true })}
        >
            {props.children}

            <div
                className={clsx(styles.DragIconContainer, styles.DragIconContainer_RowSelect)}
                onClick={(e) => handleRowSelect(e, editor, props?.element)}
            >
                <img src={dragIconHorizontal} alt="drag" height={'16px'} />
            </div>

            <div
                className={clsx(styles.DragIconContainer, styles.DragIconContainer_ColumnSelect)}
                onClick={(e) => handleColumnSelect(e, editor, props?.element)}
            >
                <img src={dragIconHorizontal} alt="drag" height={'16px'} />
            </div>
        </th>
    );
}

export default TableHeader;
